@if(open)
{<div class="rms-prompt-backdrop" (click)="onBackdropClick()">
  <div class="rms-prompt-container" (click)="$event.stopPropagation()">
    <div class="rms-prompt-body" style="display: flex; flex-direction: column; align-items: center;">
      @if(promptText){<h3 class="rms-prompt-text">{{ promptText }}</h3>}
      @if(htmlPrompt){
      <div class="rms-prompt-text" [innerHTML]="htmlPrompt"></div>
      }
      @if(promptInput){
      <form #PromptForm="ngForm">
        @switch(promptInput){
        @case('textarea'){
        <rms-textarea [focusOnLoad]="true" name="textAreaInput" [required]="inputRequired" [label]="inputLabel" [(ngModel)]="inputValue"></rms-textarea>
        }
        @case('text'){
        <rms-input [focusOnLoad]="true" name="textInput" [required]="inputRequired" [label]="inputLabel" [(ngModel)]="inputValue"></rms-input>
        }
        @case('select'){
        <rms-select [options]="inputOptions" name="inputLabel" [label]="inputLabel" [required]="inputRequired" [(ngModel)]="inputValue" labelKey="label" valueKey="value"></rms-select>
        }
        @case('date'){
        <rms-date name="dateInput" [required]="inputRequired" [label]="inputLabel" [(ngModel)]="inputValue"></rms-date>
        }
        }
      </form>
      <div class="rms-prompt-actions">
        @for (button of buttons; track $index) {
        <button mat-button [disabled]="!inputValue"
                type="button"
                (click)="onButtonClick(button)"
                [ngClass]="button.buttonClass || ''">
          @if (button.icon) {
          <mat-icon>{{ button.icon }}</mat-icon>
          }
          <span>{{ button.label }}</span>
        </button>
        }
        <button mat-button
                type="button"
                (click)="onBackdropClick()"
                class="btn-bg-red">
          Cancel
        </button>
      </div>
      }
      @else{
      <div class="rms-prompt-actions">
        @for (button of buttons; track $index) {
        <button mat-button
                type="button"
                (click)="onButtonClick(button)"
                [ngClass]="button.buttonClass || ''">
          @if (button.icon) {
          <mat-icon>{{ button.icon }}</mat-icon>
          }
          <span>{{ button.label }}</span>
        </button>
        }
        <button mat-button
                type="button"
                (click)="onBackdropClick()"
                class="btn-bg-red">
          Cancel
        </button>
      </div>
      }
    </div>
  </div>
</div>
}
